import React from 'react';
import { Link } from 'react-router-dom';

import Icon from 'Core/Components/Icon';
import Submit from 'RLX/Forms/Submit';
import Fieldset from 'RLX/Forms/Fieldset';
import ButtonGroup from 'RLX/Forms/ButtonGroup';

import { isValid } from 'Core/Utils/Validation';

const DEV_DEFAULTS = {
  email: '', //'me@austinbillings.com',
  pass: '', //'lalalalala',
  confirm: '', //'lalalalala',
  name: '' //'Axonomy Nakomura'
};

class AuthForm extends React.Component {
  constructor (props) {
    super(props);

    const defaults = DEV_DEFAULTS;//{ email: '', pass: '', name: '' };
    this.state = { ...defaults, ...props };

    this.onSubmit = this.onSubmit.bind(this);
    this.isSubmittable = this.isSubmittable.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  handleEmailChange (email) {
    this.setState({ email });
  }

  handlePassChange (pass) {
    this.setState({ pass });
  }

  handleNameChange (name) {
    this.setState({ name });
  }

  onSubmit (event) {
    event.preventDefault();
    const { handleSubmit, state } = this;
    if (typeof handleSubmit === 'function') handleSubmit(state);
  }

  getFields () { return []; }
  getButtons () { return []; }

  isSubmittable () {
    const fields = this.getFields();
    return fields.reduce((result, field) => {
      if (!result) return result;
      if (field.required && (!field.value || !field.value.length)) return false;
      if (field.validate && !isValid(field.value, field.validate)) return false;
      return result;
    }, true);
  }

  render () {
    const { children } = this.props;
    const { onSubmit } = this;

    const fields = this.getFields();
    const buttons = this.getButtons();

    return (
      <form className="AuthForm" onSubmit={onSubmit}>
        <Fieldset fields={fields} />
        <div className="AuthForm-Children" children={children} />
        <ButtonGroup buttons={buttons} />
      </form>
    );
  }
};

export default AuthForm;



// WEBPACK FOOTER //
// ./client/RLX/Controllers/AuthFormController.jsx